import { Form } from '@/features/settings/components/PrinterConfiguration/form/types'
import { SunmiPrinterInfo } from '@/modules/sunmi-printer'

const normalizeSunmiPaperWidth = (paper: string | null): number | null => {
    // PrinterX may report printable head width in dots: 384 for 58 mm, 576 for 80 mm.
    switch (paper?.trim().toLowerCase()) {
        case '384':
        case '58mm':
            return 58
        case '576':
        case '80mm':
            return 80
        default:
            return null
    }
}

export const mapSunmiPrinterInfoToInitialFormValues = (
    printerInfo: SunmiPrinterInfo
): Partial<Form> => {
    const paperWidth = normalizeSunmiPaperWidth(printerInfo.paper)
    const name = printerInfo.name ?? ''

    if (paperWidth === 80) {
        return {
            name,
            paperWidth: '80',
            charsPerLine: '48',
        }
    }

    if (paperWidth === 58) {
        return {
            name,
            paperWidth: '58',
            charsPerLine: '32',
        }
    }

    return { name }
}
